import React from 'react';
import { Input, Select, Radio, Checkbox, Row, Col, DatePicker, Icon } from 'antd';
import SelectPlaceHolder from '../../../components/SelectPlaceHolder';
import moment from 'moment';
const { Option } = Select;
const InputGroup = Input.Group;

export default class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16} align="middle">
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha inicio"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaInicioStr === '' ? null : moment(this.props.filter.fechaInicioStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaInicioStr', value)}
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha fin"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaFinStr === '' ? null : moment(this.props.filter.fechaFinStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaFinStr', value)}
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <Select showSearch labelInValue
                            value={this.props.filter.idMoneda ? { key: this.props.filter.idMoneda } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por Moneda" />}
                            onChange={(option) => this.props.onChange("idMoneda", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.monedas.map(item => (
                                <Select.Option key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>

                    {
                        this.props.filter.tipoReporte == 3 ?
                            <Col className="gutter-row" sm={24} md={12} lg={4}>
                                <Select
                                    showSearch labelInValue
                                    value={this.props.filter.idEstablecimiento ? { key: this.props.filter.idEstablecimiento } : undefined}
                                    placeholder={<SelectPlaceHolder label="Filtrar por establecimiento" />}
                                    onChange={(option) => this.props.onChange("idEstablecimiento", option.key)} //STATE PROPERTY
                                    optionFilterProp="children"
                                    loading={this.props.establecimientosLoading}
                                >
                                    <Option key={'0'} value={'0'}>
                                        <span>TODOS</span>
                                    </Option>
                                    {this.props.establecimientos.map(item => (
                                        <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                                    ))}
                                </Select>
                            </Col> : null
                    }

                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch labelInValue
                            value={this.props.filter.idMarca ? { key: this.props.filter.idMarca } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por marca" />}
                            onChange={(option) => this.props.onChange("idMarca", option.key)}
                            optionFilterProp="children"
                        >
                            <Option key={'0'} value={'0'}>
                                <span>TODOS</span>
                            </Option>
                            {this.props.marcas.map(item => (
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idProyecto ?
                                    { key: this.props.filter.idProyecto } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por Proyecto" />}
                            onChange={(option) => this.props.onChange("idProyecto", option.key, option, 'proyecto')}
                            optionFilterProp="children"
                        >
                            <Select.Option value="0" key="0">TODOS</Select.Option>
                            {this.props.proyectos.map(item => ( //STATE DATA

                                <Select.Option value={item.id} key={item.id}  >{item.nombre}</Select.Option>

                            ))}
                        </Select>
                    </Col>

{/*                     <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Select showSearch labelInValue
                            value={this.props.filter.idProducto ? { key: this.props.filter.idProducto } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por Producto" />}
                            onChange={(option) => this.props.onChange("idProducto", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.productos.map(item => (
                                <Select.Option key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col> */}

                    <Col className="gutter-row" sm={24} md={12} lg={7}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.referencia}
                            onChange={(e) => this.props.onChange("referencia", e.target.value)}
                            placeholder="Filtrar por codigo referencia"
                            autoComplete="off"
                        />
                    </Col>

                    {this.props.filter.tipoReporte == 3 ?

                        <>
                            <Col className="gutter-row" sm={24} md={12} lg={6}>
                                <Select showSearch labelInValue
                                    value={this.props.filter.idProveedor ? { key: this.props.filter.idProveedor } : undefined}
                                    placeholder={<SelectPlaceHolder label="Filtrar por Proveedor" />}
                                    onChange={(option) => this.props.onChange("idProveedor", option.key)}
                                    optionFilterProp="children"
                                >
                                    {this.props.proveedores.map(item => (
                                        <Select.Option key={item.id}>{item.nombre}</Select.Option>
                                    ))}
                                </Select>
                            </Col>
                            <Col className="gutter-row" sm={24} md={12} lg={3}>
                                <Input
                                    prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                    value={this.props.filter.serie}
                                    onChange={(e) => this.props.onChange("serie", e.target.value)}
                                    onKeyUp={this.props.onKeyUpSearch}
                                    placeholder="Filtrar por serie"
                                    autoComplete="off"
                                />
                            </Col>
                            <Col className="gutter-row" sm={24} md={12} lg={3}>
                                <Input
                                    prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                    value={this.props.filter.documento}
                                    onChange={(e) => this.props.onChange("documento", e.target.value)}
                                    onKeyUp={this.props.onKeyUpSearch}
                                    placeholder="Filtrar por documento"
                                    autoComplete="off"
                                />
                            </Col>
                        </>
                        : null
                    }
                </Row>
                <Row gutter={16} align="middle">
                    <Col className="gutter-row" sm={24} md={24} lg={6}>
                        <div style={{ height: '32px', display: 'flex', alignItems: 'left', justifyContent: 'left' }} >
                            <Radio.Group
                                value={this.props.filter.tipoReporte}
                                onChange={(e) => this.props.onChange("tipoReporte", e.target.value)}
                            >
                                <Radio value={1}>Ranking</Radio>
                                <Radio value={2}>Resumen</Radio>
                                <Radio value={3}>Detallado</Radio>
                            </Radio.Group>
                        </div>
                    </Col>

                </Row>
            </div>
        );
    }
}